// Global Enums
import {
  adminPages,
  adminSections,
} from 'common.enums';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';

// Components
import Page from '../../layout/Page';
import ProfileHeaderSection from '../../sections/ProfilePageSections/ProfileHeaderSection';
import ProfileSettingsSection from '../../sections/ProfilePageSections/ProfileSettingsSection';
import ProfileInvoiceDetailsSection from '../../sections/ProfilePageSections/ProfileInvoiceDetailsSection';
import ProfileInvoicesSection from '../../sections/ProfilePageSections/ProfileInvoicesSection';

const pageId = adminPages.profilePage;

const ProfilePageView = function () {
  return (
    <Page id={pageId}>
      <ProfileHeaderSection id={adminSections[pageId].header} />
      <Row>
        <Col sm={6}>
          <ProfileSettingsSection id={adminSections[pageId].settings} />
        </Col>
        <Col sm={6}>
          <ProfileInvoiceDetailsSection id={adminSections[pageId].invoiceDetails} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ProfileInvoicesSection id={adminSections[pageId].invoices} />
        </Col>
      </Row>
    </Page>
  );
};

export default ProfilePageView;
